import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UserProfile } from 'src/app/model/userProfile.model';
import moment from 'moment-timezone';

@Component({
  selector: 'app-my-info',
  templateUrl: './my-info.component.html',
  styleUrls: ['./my-info.component.css',
    '../../../../node_modules/primeflex/primeflex.css']
})
export class MyInfoComponent implements OnInit, OnChanges {

  @Input() user: UserProfile;
  @Output() emitSave: EventEmitter<any> = new EventEmitter();

  tzones: any[] = [];
  userForm: FormGroup;
  constructor(
    private fb: FormBuilder
  ) {
    moment.tz.names().forEach(timezone => {
      this.tzones = [...this.tzones, {
        name: timezone, code: timezone
      }];
    });
  }

  ngOnInit() {
    this.buildUserForm();
  }

  ngOnChanges() {
    this.buildUserForm();
  }

  buildUserForm() {
    this.userForm = this.fb.group({
      uId: [this.user && this.user.uId || '', Validators.required],
      first: [this.user && this.user.first || '', Validators.required],
      last: [this.user && this.user.last || '', Validators.required],
      email: [this.user && this.user.email || '', Validators.required],
      tzone: [this.user && this.user.tzone || null]
    });
    this.userForm.disable();
  }

  saveUser(event) {
    if (!this.userForm.dirty) {
      this.userForm.disable();
      return;
    }
    if (this.userForm.valid) {
      this.emitSave.emit(this.userForm.value);
    }
    this.userForm.disable();
  }

  editUser(event) {
    this.userForm.enable();
  }

  cancelEdit($event) {
    this.userForm.disable();
  }
}
